<template>
  <div class="w-100">
    <div class="d-table mb-4" v-if="!show_map">
      <button class="ga-btn ga-btn-primary ga-btn-lg px-4" @click="showMap()">Show Map</button>
    </div>
    <div class="w-100" ref="map_section">
      <gmap-map  
        v-if="show_map"
        :options="option"
        :center="map.center" 
        :zoom="15" 
        style="width:100%;  height: 400px;">
        <gmap-marker :key="index" v-for="(m, index) in map.markers" :position="m.position" :clickable="true" @click="openGmaps()"></gmap-marker>
      </gmap-map>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        option: {
          mapTypeControl: false,
          streetViewControl: false,
          panControl: false,
          rotateControl: false,
          scaleControl: false,
          gestureHandling: 'greedy'
        },
        map:{
          center: { lat: null, lng: null },
          markers: []
        },
        scroll_position: 0,
        show_map: false,
        map_position: 0
      }
    },
    computed:{
      ...mapGetters(['getMerchant']),
    },
    watch:{
      // scroll_position(){
      //   const screen_height = window.innerHeight
      //   const distance = (this.map_position-screen_height) - this.scroll_position;
      //   if (distance < 0 && !this.show_map) {
      //     this.show_map = true
      //   }
      // }
    },
    mounted(){
      // window.addEventListener('scroll', this.handleScroll);
      this.map.center = {
        lat : this.getMerchant.lat,
        lng : this.getMerchant.lng
      }
      this.map.markers = []
      this.map.markers.push({ position: this.map.center });
      // this.map_position = this.$refs.map_section.getBoundingClientRect().top
    },
    methods:{
      // handleScroll(){
      //   this.scroll_position = window.scrollY || window.pageYOffset;
      // },
      openGmaps(){
        let tag_a = document.createElement('a')
        tag_a.href = `https://maps.google.com/?q=${this.getMerchant.lat},${this.getMerchant.lng}`
        tag_a.target = '_blank'
        tag_a.click()
        tag_a.remove()
      },
      showMap(){
        this.show_map = true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/general/ShowGmaps.vue